<template>
  <div
    class="part-adapted border1px"
    v-track="{
      act: 'show',
      params: {
        cfrom: '081|071|02|077',
        event_id: '081|071|02|077',
        sku_id: skuId,
        model: adaptedInfo.modelName,
        result: trackTypeResult,
        isno_content: trackTypeResult != 3 || adaptedInfo.hasOriginalCmmdy ? 1 : 2
      }
    }"
  >
    <template v-if="adaptedInfo.partAdaptedToModelType == 1">
      <div class="adapted-enable" @click="showAdaptedPopup" tabindex="0">
        您的
        <span class="c-blue adapted-link">{{ adaptedInfo.modelName }}原装配件</span>
      </div>
    </template>
    <template v-if="adaptedInfo.partAdaptedToModelType == 2">
      <div class="adapted-enable" @click="showAdaptedPopup" tabindex="0">
        <span class="text-bold c-00">适用</span>
        <span class="adapted-model adapted-tip">您的{{ adaptedInfo.modelName }}</span>
      </div>
    </template>
    <template v-if="adaptedInfo.partAdaptedToModelType == 4">
      <div class="adapted-disable">
        <span :aria-label="`不适用您的${adaptedInfo.modelName}`">
          <span class="adapted-type text-bold c-00" aria-hidden="true">不适用</span>
          <span class="adapted-model" aria-hidden="true">您的{{ adaptedInfo.modelName }}</span>
        </span>
        <span v-if="adaptedInfo.hasOriginalCmmdy" class="adapted-link text-bold c-00" @click="showListPopup">
          去
          <span class="c-blue">购买原装配件</span>
        </span>
      </div>
    </template>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'part-adapted-type',
  props: {
    skuInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    adaptedInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    skuId() {
      return this.skuInfo?.commoditySkuBaseInfo.skuId
    },
    trackTypeResult() {
      if (this.adaptedInfo.partAdaptedToModelType == 4) return 3
      return this.adaptedInfo.partAdaptedToModelType
    }
  },
  methods: {
    ...mapActions('detailv3', ['savePreFocusElByEvent']),
    showAdaptedPopup(e) {
      this.savePreFocusElByEvent(e)
      this.trackClick()
      this.$emit('adaptedShow')
    },
    showListPopup() {
      this.trackClick()
      this.$emit('listShow')
    },
    trackClick() {
      this.$track({
        cfrom: '081|071|01|077',
        event_id: '081|071|01|077',
        model: this.adaptedInfo.modelName,
        sku_id: this.skuId,
        result: this.trackTypeResult
      })
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
